import React, { useEffect, useState, useCallback } from 'react';
import { useApi } from '../../hooks/useApi';
import { useClub } from '../../hooks/useClub';

export default function LeadSuppressed() {
  const { get } = useApi();
  const { currentClub } = useClub();
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [search, setSearch]   = useState('');

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    get(`/lead/suppressed?club=${currentClub.id}`)
      .then(setData)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [currentClub.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}><div className="spinner" /></div>;
  if (error)   return <div style={{ padding: 24, color: 'var(--red)', textAlign: 'center' }}>Failed to load — {error}</div>;

  const list = (data?.suppressed || []).filter(r => {
    if (!search.trim()) return true;
    const s = search.toLowerCase();
    return r.name?.toLowerCase().includes(s) || r.email?.toLowerCase().includes(s) || r.phone?.includes(search);
  });

  return (
    <div>
      {/* Header */}
      <div style={{ background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 12, color: 'var(--red)' }}>
        🚫 <strong>Hard Suppression</strong> — DNC members are permanently removed from ALL pipelines. This list is for audit purposes only. Records cannot be re-activated.
      </div>

      {/* KPI */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 7, padding: '6px 16px', textAlign: 'center' }}>
          <div style={{ fontSize: 9, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 2 }}>Total DNC</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--red)', fontFamily: 'DM Mono, monospace' }}>{data?.total || 0}</div>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: 16 }}>
        <input
          className="field-input"
          type="text"
          placeholder="Search by name, email, phone..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>

      {/* List */}
      {list.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">✅</div>
          <div className="empty-state-text">{search ? 'No matches found.' : 'No suppressed members.'}</div>
        </div>
      ) : (
        list.map(r => (
          <div key={r.id} style={{
            background: 'var(--surface-2)', border: '1px solid var(--border)',
            borderRadius: 8, padding: '10px 14px', marginBottom: 6,
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13 }}>{r.name}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
                {r.email} {r.phone ? `· ${r.phone}` : ''}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
              <span style={{ background: 'rgba(220,38,38,0.2)', color: 'var(--red)', fontSize: 9, fontWeight: 700, padding: '2px 8px', borderRadius: 4 }}>
                DNC — {r.reason || 'Hard Suppress'}
              </span>
              <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>
                {r.suppressedAt} · {r.suppressedBy || 'System'}
              </span>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
